export const defaultStore = {
  isLoggedIn: false,
  reloadClient: false,
  xolasClient: {},
  org: {},
  profile: {},
  stats: {},
  statsError: false,
  debug: false,
  isChrome: null,
  isSafari: null,
  env: null,
  endpoint: null,
  hostname: null,
  copyright: null,
  windowWidth: null,
  windowHeight: null,
  // KAN-39: session JWT auth. NOT persisted via vuex-persistedstate;
  // tokens live in sessionStorage (per-tab) instead.
  auth: {
    accessToken: null,
    refreshToken: null,
    claims: null,
    expiresAt: null
  }
}



// WEBPACK FOOTER //
// ./src/components/config/store.js